import React from 'react';

import Avatar from '../../assets/img/testimonial/avatar-4.png';

const SingleTestimonialTwo = (props) => {
  const { itemClass, description, avatarImage, authorName, designation } =
    props;
  return (
    <div className={itemClass ? itemClass : 'it-testimonial-item'}>
      <div className="it-testimonial-text-wrap">
        <div className="it-testimonial-ratting">
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
        </div>
        <div className="it-testimonial-text">
          <p>
            {description
              ? description
              : `“Standard dummy text ever since the unknown printer took galley of
            scramble make a type specimen book has the been industr”`}
          </p>
        </div>
        <div className="it-testimonial-quote">
          <span>
            <i className="flaticon-quote"></i>
          </span>
        </div>
      </div>
      <div className="it-testimonial-author-box d-flex align-items-center">
        <div className="it-testimonial-author mr-15">
          <img src={avatarImage ? avatarImage : Avatar} alt="" />
        </div>
        <div className="it-testimonial-author-info">
          <h5>{authorName ? authorName : 'Remedios Linared'}</h5>
          <span>{designation ? designation : 'Web designar'}</span>
        </div>
      </div>
    </div>
  );
};

export default SingleTestimonialTwo;
